import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgNudgeLocationPin = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 10.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM11.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 7.682c0 4.377-4.256 8.754-5.88 10.265a.902.902 0 0 1-1.24 0C7.756 16.436 3.5 12.059 3.5 7.682 3.5 4.268 6.41 1.5 10 1.5s6.5 2.768 6.5 6.182Zm-1.5 0c0 1.735-.861 3.615-2.065 5.353-.997 1.441-2.14 2.655-2.935 3.43-.796-.774-1.938-1.989-2.936-3.43C5.861 11.297 5 9.417 5 7.682 5 5.166 7.167 3 10 3s5 2.166 5 4.682Z"
    />
  </svg>
);
export default SvgNudgeLocationPin;
